export const roundAmount = (value, decimals = 2) => {
  const num = Number(value);
  if (Number.isNaN(num)) return 0;

  return Number(num.toFixed(decimals));
};

export const formatCurrency = (value) => {
  return `₹${roundAmount(value).toFixed(2)}`;
};
